import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
import NotFound404Exception from "@/exceptions/NotFound404Exception";
import InternalServerError500Exception from "@/exceptions/InternalServerError500Exception";
import { apiUrl } from "@globalConfig";
var pendingRequests = {};
export function fetchSearchResults(_x, _x2) {
  return _fetchSearchResults.apply(this, arguments);
}
function _fetchSearchResults() {
  _fetchSearchResults = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(req, axiosConfig) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", fetcher(req).get("/search/index", axiosConfig).then(/*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res) {
              var _res$data2, _req$query2, _res$data3;
              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) !== 200)) {
                      _context4.next = 2;
                      break;
                    }
                    throw new InternalServerError500Exception("api__doSearch", {
                      url: "search/index",
                      data: axiosConfig.params
                    });
                  case 2:
                    if (!(req !== null && req !== void 0 && (_req$query2 = req.query) !== null && _req$query2 !== void 0 && _req$query2.page && +req.query.page > res.data.data.total_pages)) {
                      _context4.next = 4;
                      break;
                    }
                    throw new NotFound404Exception("api__doSearch_page_exceeds_total_pages");
                  case 4:
                    return _context4.abrupt("return", (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data) || {});
                  case 5:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
            return function (_x7) {
              return _ref5.apply(this, arguments);
            };
          }()));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fetchSearchResults.apply(this, arguments);
}
export var api__doSearch_with_params = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var req, _ref$page, page, filters, _ref$sort, sort, _ref$link, link, _ref$size, size, includes, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          req = _ref.req, _ref$page = _ref.page, page = _ref$page === void 0 ? 1 : _ref$page, filters = _ref.filters, _ref$sort = _ref.sort, sort = _ref$sort === void 0 ? "" : _ref$sort, _ref$link = _ref.link, link = _ref$link === void 0 ? "" : _ref$link, _ref$size = _ref.size, size = _ref$size === void 0 ? 12 : _ref$size, includes = _ref.includes;
          delete filters.sort;
          delete filters.page;
          if (filters !== null && filters !== void 0 && filters.is_new && typeof (filters === null || filters === void 0 ? void 0 : filters.is_new) === "string") {
            filters.is_new = filters.is_new === "true" || filters.is_new === "1" ? 1 : 0;
          }
          if (filters !== null && filters !== void 0 && filters.odometer_to && typeof (filters === null || filters === void 0 ? void 0 : filters.odometer_to) === "string") {
            filters.odometer_to = filters.odometer_to.replaceAll(",", "");
          }
          if (filters !== null && filters !== void 0 && filters.odometer_from && typeof (filters === null || filters === void 0 ? void 0 : filters.odometer_from) === "string") {
            filters.odometer_from = filters.odometer_from.replaceAll(",", "");
          }
          filters.text = filters.text || "";
          data = {
            filters: filters,
            link: link,
            page: page,
            sort: sort || "",
            size: size,
            new_path: !!(link !== null && link !== void 0 && link.includes("/autos") || link !== null && link !== void 0 && link.includes("/years"))
          };
          _context.next = 10;
          return api__doSearch(req, page, data, includes);
        case 10:
          return _context.abrupt("return", _context.sent);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__doSearch_with_params(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__doSearch = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(req) {
    var _req$query;
    var page,
      data,
      includes,
      requestData,
      cacheKey,
      axiosConfig,
      requestPromise,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          page = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
          data = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          includes = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : [];
          if (!(req !== null && req !== void 0 && (_req$query = req.query) !== null && _req$query !== void 0 && _req$query.page && (+req.query.page < 1 || isNaN(+req.query.page)))) {
            _context2.next = 5;
            break;
          }
          throw new NotFound404Exception("api__doSearch_wrong_validation");
        case 5:
          requestData = {
            ps: "".concat(page, "-").concat(data === null || data === void 0 ? void 0 : data.size),
            includes: includes.join(","),
            search_data: JSON.stringify(data || {})
          };
          cacheKey = JSON.stringify(requestData);
          if (!(__IS_CSR__ && pendingRequests[cacheKey])) {
            _context2.next = 11;
            break;
          }
          _context2.next = 10;
          return pendingRequests[cacheKey];
        case 10:
          return _context2.abrupt("return", _context2.sent);
        case 11:
          axiosConfig = {
            params: requestData
          };
          requestPromise = fetchSearchResults(req, axiosConfig)["finally"](function () {
            if (__IS_CSR__) {
              delete pendingRequests[cacheKey];
            }
          });
          if (__IS_CSR__) {
            pendingRequests[cacheKey] = requestPromise;
          }
          _context2.next = 16;
          return requestPromise;
        case 16:
          return _context2.abrupt("return", _context2.sent);
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function api__doSearch(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var api__getUnbxdSuggestions = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(lang, searchTerm) {
    var _res$data, _res$data$data;
    var url, normalizedSearchTerm, res;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          url = (process.env.RAZZLE_ENV_UNBXD_AUTOSUGGEST_URL || "").replace("{lang}", lang).replace("{apiUrl}", apiUrl);
          normalizedSearchTerm = searchTerm || "";
          _context3.next = 4;
          return fetcher().get("".concat(url).concat(normalizedSearchTerm));
        case 4:
          res = _context3.sent;
          return _context3.abrupt("return", ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.products) || []);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function api__getUnbxdSuggestions(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();